import React, { useRef, useState } from 'react';
import Pencil from '../../../../assets/images/pencil.svg';

const CustomInput = ({
  name,
  title,
  isEditing,
  value = '',
  type = 'text',
  isTitle = false,
  onChange = () => {},
}) => {
  const [edit, setEdit] = useState(false);
  const inputRef = useRef(null);
  return (
    <div className="setting_rows">
      <p className="key">{title}</p>
      <p className="value">
        {name === 'description' ? (
          <textarea
            ref={inputRef}
            readOnly={!isEditing}
            placeholder={isEditing && `${title} goes here`}
            style={{ resize: 'none' }}
            className="main_part border-0"
            name={name}
            onChange={(e) => {
              onChange(e);
              if (inputRef) {
                inputRef.current.style.height = 'auto';
                inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
              }
            }}
          >
            {value}
          </textarea>
        ) : (
          <input
            ref={inputRef}
            type={type}
            readOnly={!isEditing || !edit}
            value={value}
            placeholder={isEditing && `${title} goes here`}
            className="main_part"
            name={name}
            onChange={onChange}
          />
        )}
        {isEditing && !isTitle && (
          <p className="edit_buttton">
            <img
              src={Pencil}
              alt=""
              onClick={() => {
                setEdit(true);
                inputRef.current.focus();
              }}
              className="cursor"
            />
          </p>
        )}
        {isEditing && isTitle && (
          <img
            className="cursor"
            src="/assets/images/right_arrow.svg"
            alt="right arrow icon"
          />
        )}
      </p>
    </div>
  );
};

export default CustomInput;
